import { Flex } from '@ifood/pomodoro-components';
import { ChevronDown, ChevronUp } from '@ifood/pomodoro-icons';
import tokens from '@ifood/pomodoro-tokens';
import React from 'react';

import { useSidebar } from '@constants/globals';
import { noop } from 'utils/js';

import { Content, DrillDown, SidebarLink } from './styles';

type PropTypes = {
  titleSidebar?: React.ReactNode;
  children?: React.ReactNode;
  active?: boolean;
  to?: string;
  onClick?: (event: React.MouseEvent | undefined) => void;
} & React.HTMLAttributes<HTMLDivElement>;

const SidebarRootItem = ({
  titleSidebar = null,
  children = null,
  to,
  active = false,
  onClick = noop,
  ...props
}: PropTypes): JSX.Element => {
  const [, setIsSidebarOpen] = useSidebar();
  const [isOpen, setIsOpen] = React.useState(true);

  const { className } = { ...props };

  return (
    <>
      <Flex
        justifyContent="space-between"
        alignItems="center"
        marginBottom={tokens.space.regular}
        paddingRight={tokens.space.regular}
      >
        <SidebarLink
          dataTestId="sidebar-root-item"
          onClick={(event): void => {
            setIsSidebarOpen(false);
            if (onClick) onClick(event);
          }}
          href={to}
          forceActive={active}
          activeClassName="active"
          className={className}
        >
          {titleSidebar}
        </SidebarLink>
        {children && (
          <DrillDown onClick={(): void => setIsOpen((wasOpen) => !wasOpen)}>
            {isOpen ? (
              <ChevronUp width={24} height={24} color={tokens.colors.primary} />
            ) : (
              <ChevronDown width={24} height={24} color={tokens.colors.primary} />
            )}
          </DrillDown>
        )}
      </Flex>
      {isOpen && <Content>{children}</Content>}
    </>
  );
};

export default SidebarRootItem;
